var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectBased(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 18,
    height: 18,
    rx: 4,
    fill: "#0083FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7948 5.00087C12.8428 4.96587 10.6167 5.98624 9.20759 7.56908C7.86099 7.59449 6.54981 8.14655 5.58444 9.11192C5.52819 9.16733 5.50819 9.25025 5.53278 9.32524C5.55777 9.40065 5.62277 9.45523 5.7011 9.46648L7.30685 9.69647L7.10853 9.91855C7.03478 10.001 7.03853 10.1265 7.11686 10.2048L9.79465 12.8826C9.83506 12.923 9.88839 12.9434 9.94214 12.9434C9.99172 12.9434 10.0413 12.9259 10.0809 12.8905L10.303 12.6922L10.5329 14.2979C10.5442 14.3762 10.6059 14.4337 10.6804 14.4587C10.6996 14.465 10.7196 14.4679 10.74 14.4679C10.7992 14.4679 10.8596 14.4421 10.9013 14.4008C11.8533 13.4488 12.4054 12.1376 12.4308 10.791C14.0153 9.37899 15.044 7.15368 14.9986 5.2042C14.9956 5.09337 14.9061 5.00379 14.7948 5.00087ZM12.8749 8.59736C12.672 8.80027 12.4054 8.90193 12.1383 8.90193C11.8712 8.90193 11.6046 8.80027 11.4017 8.59736C10.9958 8.19113 10.9958 7.53033 11.4017 7.1241C11.8079 6.71787 12.4687 6.71787 12.8749 7.1241C13.2811 7.53033 13.2811 8.19155 12.8749 8.59736Z",
    fill: "#EEF6FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.13497 12.0435C5.68916 12.4893 5.0771 14.5033 5.00877 14.7313C4.98669 14.8046 5.00711 14.8842 5.06085 14.9383C5.10085 14.9783 5.15377 14.9996 5.20835 14.9996C5.22835 14.9996 5.24834 14.9967 5.26834 14.9908C5.49625 14.9225 7.51032 14.3104 7.95613 13.8646C8.45819 13.3626 8.45819 12.5455 7.95613 12.0435C7.45365 11.5414 6.63703 11.5418 6.13497 12.0435Z",
    fill: "#EEF6FE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectBased);
export default __webpack_public_path__ + "static/media/projectBased.23643189.svg";
export { ForwardRef as ReactComponent };